import { Component, OnInit, Input } from "@angular/core";

import { TranslateService } from "./translate.service";
import { SdpIcon } from "../icon/models";
import { environment } from "environments/environment";

interface Language {
	display: string;
	value: string;
	icon: SdpIcon.Icon;
}

@Component({
	selector: "sdp-translate",
	templateUrl: "./translate.component.html",
})

export class TranslateComponent implements OnInit {
	public production = environment.production;
	public translatedText = "";
	public readonly dropdownIcon = { type: "material", name: "arrow_drop_down", cssClass: "sdp-translate-select-icon" };
	private ENGLISH: Language = { display: "English", value: "en", icon: { type: "material", name: "flag" } };
	private ESPANOL: Language = { display: "Español", value: "es", icon: { type: "material", name: "flag" } };
	private XLANG: Language = { display: "X Lang", value: "xx", icon: { type: "material", name: "polymer" } };

	public supportedLangs: Language[] = [];
	@Input() public display = "button";
	public selectedLang = this.ENGLISH;

	constructor(
		private _translate: TranslateService,
	) { }

	public ngOnInit() {
		// do not use translate in prod. yet!! xlang and spanish are not end user viewable currently
		if (!environment.production) {
			this.supportedLangs = [
				this.ENGLISH,
				// this.ESPANOL,
				this.XLANG
			];
		}
		// default selected language is english
		this.selectLang(this.selectedLang);
	}

	public isCurrentLang(lang: string) {
		// check if the selected lang is current lang
		return lang === this._translate.currentLang;
	}

	public selectLang(lang: Language) {
		// set current lang;
		this.selectedLang = lang;
		this._translate.use(lang.value);
		this.refreshText();
	}

	public refreshText() {
		// refresh translation when language change
		this.translatedText = this._translate.instant("hello world");
	}
}
